<template>
  <div>
    <v-card class="ma-2">
      <v-card-title><T>Фильтры</T></v-card-title>
      <v-card-text>
        <div style="width: 100%;" class="d-flex">
          <DateFilter :minusDaysForStartDate="30" ref="dateFilter" />
          <v-btn class="mx-2" fab dark color="success" @click="updateData">
            <v-icon dark>mdi-autorenew</v-icon>
          </v-btn>
        </div>
        <div>
          <TextField
          dense
          class="mx-2 shrink"
          v-model="searchQuery"
          prepend-inner-icon="mdi-magnify"
          label="Поиск"
          single-line
          hide-details
          style="height: 40px; width: 300px;"
          />
        </div>
      </v-card-text>
    </v-card>

    <v-card class="ma-2">
      <v-card-title><T>Отчет по гостям</T></v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="filteredTableData"
          :loading="tableLoad"
          :loading-text="$t('Данные загружаются...')"
          :no-data-text="$t('Данные не найдены')"
          hide-default-footer
        >
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DateFilter from '../../components/orders/DateFilter.vue';
  import TextField from '../../components/common/TextField.vue'
export default {
  name: 'guestsReport',

  components: {
    DateFilter,
    TextField
  },

  computed: {
    formattedTableData() {
      return this.tableData.map(item => ({
        ...item,
        name: item.name === 'ИТОГО' ? this.$t('ИТОГО') : item.name
      }));
    },
    headers() {
      return [
        { text: this.$t('ФИО'), align: 'start', value: 'name' },
        { text: this.$t('Кол-во заказов'), align: 'center', value: 'order_count' },
        { text: this.$t('Сумма'), align: 'center', value: 'sum' },
        { text: this.$t('Средней чек'), align: 'center', value: 'average' }
      ];
    },
    filteredTableData() {
      if (!this.searchQuery) {
      return this.formattedTableData;
      }
      const query = this.searchQuery.toLowerCase();
      return this.formattedTableData.filter(item => {
      return (
          String(item.id).toLowerCase().includes(query) ||
          (item.name && item.name.toLowerCase().includes(query)) ||
          (item.phone_number && item.phone_number.toLowerCase().includes(query)) ||
          (item.orderType && item.orderType.toLowerCase().includes(query))
      );
      });
    }
  },

  data() {
    return {
      tableData: [],
      tableLoad: false,
      dateBegin: null,
      dateEnd: null,
      searchQuery: ''
    };
  },

  async mounted() {
    this.resetTable();
  },

  methods: {
    async resetTable() {
      this.dateBegin = this.$refs.dateFilter.getDateBegin();
      this.dateEnd = this.$refs.dateFilter.getDateEnd();
      this.tableLoad = true;
      this.tableData = await this.$store.dispatch('getGuestsReportInfo', {
        date_begin: this.dateBegin,
        date_end: this.dateEnd
      });
      this.tableLoad = false;
    },

    updateData() {
      this.resetTable();
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    }
  }
};
</script>

<style scoped>
</style>